import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	container: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		width: "100%",
	},
	colorCircle: {
		width: "26px",
		height: "26px",
		borderRadius: 4,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff",
		fontWeight: "bold",
		marginRight: "8px",
	},
});

type CategoryTagProps = {
	value: {
		name: string;
		color: string;
	};
};

export const CategoryTag = ({
	value,
}: {
	value: CategoryTagProps["value"];
}) => {
	const classes = useStyles();

	if (!value || !value.name || !value.color) {
		return null;
	}

	return (
		<Grid container direction="row" spacing={1}>
			<Grid item md={2}>
				<div
					title={value.name}
					className={classes.colorCircle}
					style={{ backgroundColor: value.color }}
				>
					{value.name.charAt(0).toUpperCase()}
				</div>
			</Grid>
			<Grid item justifyContent="center" md={10}>
				{value.name}
			</Grid>
		</Grid>
	);
};
